/* eslint 'no-array-constructor': 'off', 'no-loop-func' : 'off', eqeqeq: 'off'  */
import React, { Component } from 'react';
import { Row, Col, Button, FormGroup, Label, Table, Modal } from 'reactstrap';
import '../../../../../../Assets/EnsembleStyles/EnsCreateTenant.css';
import {FaQuestionCircle} from 'react-icons/fa';
import { Redirect } from 'react-router-dom';
import { SaveEmployeeDetailsforclient } from '../../../../../../action/manageTenantAction';
import SelectAllCheckboxes from '../../../../../../Resources/SelectAllCheckboxes';
import { GetRegularExpresions } from '../../../../../../action/EmployeeAction';
import { CheckIsLogOnNameExists } from '../../../../../../action/tenantAction';
import { connect } from 'react-redux';
import ErrorGif from '../../../../../../Assets/images/Error.gif';
import DimensionResources from '../../../../../../Resources/SystemAdmin/SystemAdmin.en-US';

let RegExpName = "^(.{1,50})$";
let MismatchErrorText;
let ErrLogOnName=true,ErrFName=true,ErrLName=true,ErrEmail=true,ErrPwd=true,ErrConfirmPwd=true,ErrResetPwd=true,ErrResetConfirmPwd=true;
class CreateTenant_Employee extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userID: -1,
            modal: false,
            redirect: false,
            back:false,
            tenantUsers: [],
            SelectedUser: [],
            IsError: false,
            IsNameError: false,
            IsPageError: false,
            ResetError:false,
            Reset:false,
            IsOktaUser:false,
            ResetPassword:"",
            ErrorDetails : "Error: You left necessary fields blank or entered invalid values.",
            SelectedZones: [],
            SelectedTemp: []
        };
        this.toggle = this.toggle.bind(this);
        this.goNext = this.goNext.bind(this);
        this.goBack = this.goBack.bind(this);
        this.OnCancelAddEmployee = this.OnCancelAddEmployee.bind(this);
        this.OnSaveTenant = this.OnSaveTenant.bind(this);
        this.OpenReset = this.OpenReset.bind(this);
        this.ResetPassword = this.ResetPassword.bind(this);
        this.CancelResetPassword = this.CancelResetPassword.bind(this);
        this.OnCheckOktaUser = this.OnCheckOktaUser.bind(this);  
    }

    componentWillMount() {
        this.props.GetRegularExpresions();
        if(this.props.ClientSideEmployeeState != undefined && this.props.ClientSideEmployeeState.length)
        {
            this.setState({ tenantUsers: this.props.ClientSideEmployeeState });
        }
    }

    goNext(e) {
        this.setState({ redirect: true });
        this.props.SaveEmployeeDetailsforclient(this.state.tenantUsers);
    }
    toggle() {
        this.setState({
            modal: !this.state.modal,
            IsError: false,
            IsNameError: false,
            IsPageError: false,
            ResetError:false,
            Reset : this.state.UserID > -1 ? !this.state.Reset : false,
            SelectedUser: [],
            userID: -1,
            IsOktaUser:false
        });
    }
    goBack(e)
    {
        this.setState({ back: true });
        this.props.SaveEmployeeDetailsforclient(this.state.tenantUsers);
    }

    OnCancelAddEmployee() {
        this.setState({
            modal: !this.state.modal,
            SelectedUser: [],
            userID: -1,
            IsOktaUser: false,
            SelectedZones: [],
            SelectedTemp: []
        });
    }

    CancelResetPassword(){
        this.setState({
            Reset:!this.state.Reset,
            ResetPassword:""
        });
    }

    DeleteEmployee(Rows) {
        this.setState({ IsPageError: false });
        var l_Employees = this.state.tenantUsers;
        var selected = false;

        for (let i = 0; i < Rows.length; i++) {
            var id = Rows[i].props.children[0].props.children.ref;
            if (this.refs[id].checked) {
                l_Employees = l_Employees.filter(el => el.Key != this.refs[id].value);
                selected = true;
            }
        }

        for (let j = 0; j < l_Employees.length; j++) {
            l_Employees[j].Key = j;
        }
        console.log(selected);
        if (selected) {

            this.setState({
                tenantUsers: l_Employees
            });
        }
        else {
            this.setState({ IsPageError: true });
        }
    }

    OnCheckOktaUser(){
        this.setState({
            IsOktaUser:!this.state.IsOktaUser
        }); 
    }

    ViewEmployeeDetailslink(UserId) {
        let lstTemps = [];
        let lSelectedUser = this.state.tenantUsers.filter(el => el.Key == UserId);
        let SelectedTemp =  lSelectedUser[0] !== undefined ? lSelectedUser[0].ZonesTemperatureAdjustment : [];
        SelectedTemp !== undefined && SelectedTemp !== null && SelectedTemp.length && SelectedTemp.forEach(el1 =>{
            if(el1.AllowTemperatureAdjustment){
                lstTemps.push(el1.ZoneId);
            }
        })
        this.setState({
            userID: UserId,
            SelectedUser: lSelectedUser,
            modal: !this.state.modal,
            IsError: false,
            IsNameError: false,
            IsOktaUser: this.state.tenantUsers.filter(el => el.Key == UserId)[0].IsTraneConnectUser,
            SelectedZones: lSelectedUser[0] !== undefined ? lSelectedUser[0].ZoneIds : [],
            SelectedTemp: lstTemps,
        });

    }

    OpenReset(){
        this.setState({
            Reset:true
        });
    }

    ResetPassword(){
        MismatchErrorText = "Error: You left necessary fields blank or entered invalid values.";
        this.OnClearResetErrors();
        var Password = this.refs.NewPassword.value;
        var ConfirmPassword = this.refs.NewConfirmPassword.value;
        var IsValidUser = true;

        var RegExpPasswordPattern = this.props.getResponse.RegularExpression[1];
        var RegexpPasswordLength = this.props.getResponse.RegularExpression[0];
        var RegexpPasswordDuplicatePattern = /([a-z0-9])\1/i;
        var RegexpPasswordDuplicateAllowed = this.props.getResponse.RegularExpression[3];
        var RegexpPasswordLogOnNameForPasswordAllowed = this.props.getResponse.RegularExpression[2];

        var LogonName = this.refs.userid.value;


        if(Password == "" || ConfirmPassword =="")
        {
            IsValidUser = false;
            ErrResetPwd = Password == "" ? false : true;
            ErrResetConfirmPwd = ConfirmPassword == "" ? false : true;
        }

        if (Password != "")
        {
                    if(!Password.match(RegExpPasswordPattern) || !Password.match(RegexpPasswordLength)){
                        IsValidUser = false;
                        ErrResetPwd = false;
                    }
                    else if(RegexpPasswordDuplicateAllowed === "False" && Password.match(RegexpPasswordDuplicatePattern)){                      
                            IsValidUser = false;
                            ErrResetPwd = false;
                            MismatchErrorText = "Invalid Password : Password Cannot Contain Repeating Characters";                    
                    }
                    else if(RegexpPasswordLogOnNameForPasswordAllowed === "False"){
                        if (LogonName !== "" && Password.toLowerCase().indexOf(LogonName.toLowerCase()) != -1) {
                            IsValidUser = false;
                            ErrResetPwd = false;
                            MismatchErrorText = "Invalid Password : Password Cannot Contain User ID";
                        }
                    }
        }
       


        if (Password != "" && ConfirmPassword !="" && Password != ConfirmPassword) {
            IsValidUser = false;
            MismatchErrorText = "Password and the confirmation password should be same.";
            ErrResetPwd = false;
            ErrResetConfirmPwd = false;
        }

        if(IsValidUser)
        {
        this.setState({ 
            ResetPassword:Password,
            ResetError: false,
            Reset:!this.state.Reset
         });
        }
        else
        {
            this.setState({ ResetError: true });
        }
    }

    GetUnitPreferenceNumber(a_UnitPreference){
        let l_ReturnValue = [];
        // Get the IP units.
        let l_DimensionIds = DimensionResources.Dimension('EditPreferences.Dimension.Text').split(',');
        if (a_UnitPreference === 0)
        {
            for(let i=0; i < l_DimensionIds.length; i++){
                let l_Key = DimensionResources.Dimension('EnumEditPreferences.cboUnits.IP.'+ l_DimensionIds[i].trim() +'.Text');
                if (l_Key !== undefined) {
                    l_ReturnValue.push({
                        key: Number(l_DimensionIds[i]),
                        value: Number(l_Key.split(',')[0])
                    });
                }
            }
        }
        // Get the SI units.
        if (a_UnitPreference == 1)
        {
            for(let i=0; i < l_DimensionIds.length; i++){
                let l_Key = DimensionResources.Dimension('EnumEditPreferences.cboUnits.SI.'+ l_DimensionIds[i].trim() +'.Text');
                if (l_Key !== undefined) {
                    l_ReturnValue.push({
                        key: Number(l_DimensionIds[i]),
                        value: Number(l_Key.split(',')[0])
                    });
                }
            }
        }
        return l_ReturnValue;
    }


    OnSaveTenant(Rows) {
        this.setState({ IsError: false, IsNameError: false, ErrorDetails: "Error: You left necessary fields blank or entered invalid values." });
        this.OnClearErrors();
        var lstZones = [], lstZonesTemp = [];
        var lstZoneNames = [];
        var EmployeeList = this.state.tenantUsers;
        var IsValidUser = true;
        let isOktaUser = this.state.IsOktaUser;
        var Username="^(([a-zA-Z0-9]|[!#$%&'*+/=?^_`{|}~-])[\\.]?)*([a-zA-Z0-9]+[!#$%&'*+/=?^_`{|}~-]*|[a-zA-Z0-9]*[!#$%&'*+/=?^_`{|}~-]+)[@]{1}([a-zA-Z0-9_-]*([\\.]?[a-zA-Z0-9_]+)+)$";
        var RegExpOnlySpecialCharacters = /^[^a-zA-Z0-9]+$/;
        var RegExpPasswordPattern = this.props.getResponse.RegularExpression[1];
        var RegexpPasswordLength = this.props.getResponse.RegularExpression[0];
        var RegExpLogonNamePattern = this.props.getResponse.RegularExpression[5];
        var RegexpLogonNameLength = this.props.getResponse.RegularExpression[4];
        var RegexpPasswordDuplicatePattern = /([a-z0-9])\1/i;
        var RegexpPasswordDuplicateAllowed = this.props.getResponse.RegularExpression[3];
        var RegexpPasswordLogOnNameForPasswordAllowed = this.props.getResponse.RegularExpression[2];


        for (let i = 0; i < Rows.length; i++) {
            var id = Rows[i].props.children[3].props.children.ref;
            var Tempid = Rows[i].props.children[4].props.children.ref;
            if (this.refs[id].checked) {
                let ZoneId = this.refs[id].value;
                let ZoneName = Rows[i].props.children[0].props.children;
                lstZones.push(ZoneId);
                lstZoneNames.push(ZoneName);
                lstZonesTemp.push({"ZoneId":this.refs[Tempid].value, "AllowTemperatureAdjustment": this.refs[Tempid].checked});
            }
        }

        var LogonName = this.refs.userid.value;
        var FirstName = this.refs.firstName.value;
        var LastName = this.refs.lastName.value;
       
        if(!isOktaUser){
            var Password = "";
            if (this.state.userID > -1 && this.state.ResetPassword == "") {
                Password = this.state.tenantUsers.filter(el => el.Key == this.state.userID)[0].Password;
            }
            else if (this.state.userID > -1) {
                Password = this.state.ResetPassword;
            }
            else {
                Password = this.refs.password.value;
            }

            var ConfirmPassword = "";
            if (this.state.userID > -1 && this.state.ResetPassword == "") {
                ConfirmPassword = this.state.tenantUsers.filter(el => el.Key == this.state.userID)[0].Password;
            }
            else if (this.state.userID > -1) {
                ConfirmPassword = this.state.ResetPassword;
            }
            else {
                ConfirmPassword = this.refs.confirmPassword.value;
            }
        }

        var Key = (this.state.userID > -1) ? this.state.tenantUsers.filter(el => el.Key == this.state.userID)[0].Key : (this.state.tenantUsers == undefined) ? 0 : this.state.tenantUsers.length;
        var EmployeeEmail = this.refs.email.value;
        var EmployeePreference = this.refs.displayTemp.options.selectedIndex;
        var Zonename = lstZoneNames.join(',');
       
        
        if(!isOktaUser){
            if (LogonName == "" || FirstName == "" || LastName == "" || Password == "" || ConfirmPassword == "") {
                IsValidUser = false;
                ErrLogOnName = LogonName == "" ? false : true;
                ErrFName = FirstName == "" ? false : true;
                ErrLName = LastName == "" ? false : true;
                ErrPwd = Password == "" ? false : true;
                ErrConfirmPwd = ConfirmPassword == "" ? false : true;
            }
            if (LogonName != "" && LogonName.match(RegExpOnlySpecialCharacters)){
                IsValidUser = false;
                ErrLogOnName = false;
            }

            if (LogonName != "" && (!LogonName.match(RegExpLogonNamePattern) || !LogonName.match(RegexpLogonNameLength))) {
                IsValidUser = false;
                ErrLogOnName = false;
            }

            

            if (Password != "")
            {
                if(!Password.match(RegExpPasswordPattern) || !Password.match(RegexpPasswordLength)){
                    IsValidUser = false;
                    ErrPwd = false;
                }
                else if(RegexpPasswordDuplicateAllowed === "False" && Password.match(RegexpPasswordDuplicatePattern)){                      
                        IsValidUser = false;
                        ErrPwd = false;  
                        this.setState({ErrorDetails:"Invalid Password : Password Cannot Contain Repeating Characters"});                    
                }
                else if(RegexpPasswordLogOnNameForPasswordAllowed === "False"){
                    if (LogonName !== "" && Password.toLowerCase().indexOf(LogonName.toLowerCase()) != -1) {
                        IsValidUser = false;
                        ErrPwd = false;
                        this.setState({ErrorDetails:"Invalid Password : Password Cannot Contain User ID"});
                    }
                }
            }

            if (Password != ConfirmPassword) {
                IsValidUser = false;
                ErrPwd = false;
                ErrConfirmPwd = false;
                this.setState({ErrorDetails:"Password and the confirmation password should be same."});
            }
        }else{
            if (LogonName == "" || FirstName == "" || LastName == "") {
                IsValidUser = false;
                ErrLogOnName = LogonName == "" ? false : true;
                ErrFName = FirstName == "" ? false : true;
                ErrLName = LastName == "" ? false : true;
            }
        }
        if (FirstName != "" && !FirstName.match(RegExpName)) {
            IsValidUser = false;
            ErrFName = false;
        }

        if (LastName != "" && !LastName.match(RegExpName)) {
            IsValidUser = false;
            ErrLName = false;
        }

        if (EmployeeEmail != "" && !EmployeeEmail.match(Username)) {
            IsValidUser = false;
            ErrEmail = false;
        }

        if(LogonName !== "" && LogonName !== null && isOktaUser){
            if(!LogonName.match(Username) || LogonName.match(RegExpOnlySpecialCharacters)){
                IsValidUser = false;
                ErrLogOnName = false;
            }
        }

        if(isOktaUser)
            Password = "";

        let lEmployeePreference = this.GetUnitPreferenceNumber(EmployeePreference);

        if (IsValidUser) {

            if (this.state.userID > -1) {
                EmployeeList = EmployeeList.filter(el => el.Key != this.state.userID);
            }

            const actionResponse = this.props.CheckIsLogOnNameExists(LogonName);
            actionResponse.then((result) => {
                if (!this.props.IsUserIdNameExixts) {
                    EmployeeList.push({ TenantUserId: 0, TenantId: 0, FirstName: FirstName, LastName: LastName, LogOnName: LogonName, Password: Password, IsActive: true, Key: Key, EmployeeEmail: EmployeeEmail, EmployeePreference: EmployeePreference, ZoneIds: lstZones, ZoneName: Zonename, PreferenceUnits : JSON.stringify(lEmployeePreference), IsTraneConnectUser:isOktaUser, ZonesTemperatureAdjustment: lstZonesTemp })

                    this.setState({
                        tenantUsers: EmployeeList,
                        modal: !this.state.modal,
                        userID: -1,
                        SelectedUser: [],
                        SelectedZones: [],
                        SelectedTemp: []
                    });
                }
                else
                    this.setState({ IsNameError: true });
            })


        }
        else {
            this.setState({ IsError: true });
        }
    }

    OnClearErrors(){
        ErrLogOnName=true;
        ErrFName=true;
        ErrLName=true;
        ErrEmail=true;
        ErrPwd=true;
        ErrConfirmPwd=true;
    }

    OnClearResetErrors(){
        ErrResetPwd=true;
        ErrResetConfirmPwd=true;
    }

    OnClickHeaderChk(HeaderChk, ChildChk, IsZoneChk){
        var header_Checkbox = document.getElementsByClassName(HeaderChk);
        var child_checkboxes = document.getElementsByClassName(ChildChk);
        var lstZones = [], lstTemps = [];

        if(child_checkboxes !== undefined && child_checkboxes !== null && child_checkboxes.length){
            if(header_Checkbox[0].checked){
                if(IsZoneChk) 
                    lstZones = Array.from(child_checkboxes).map(elem => elem.value);
                else
                    lstTemps = Array.from(child_checkboxes).map(elem => elem.value);
            }
        }

        if(IsZoneChk){
            lstTemps = this.state.SelectedTemp;
            if(!header_Checkbox[0].checked){
                lstTemps = [];
                this.refs.ref_TempHeader_chk.checked = false;
            }
            this.setState({ SelectedZones : lstZones, SelectedTemp : lstTemps });
        }else{
            this.setState({ SelectedTemp : lstTemps });
        }
    }

    OnClickChildChk = (HeaderChk, ChildChk, IsZoneChk) => {
        var lstZones = [], lstTemps = [];
        var ZoneChildChks = Array.from(document.getElementsByClassName(ChildChk)).filter(el => el.disabled === false);
        if(IsZoneChk){
            var lst_Zones = ZoneChildChks.map(elem => { return elem.checked ? elem.value : ""});
            lstZones = (lst_Zones !== undefined && lst_Zones !== null && lst_Zones.length) ? lst_Zones.filter(el => el !== "") : [];
            if(ZoneChildChks.length !== lstZones.length) this.refs.ref_TempHeader_chk.checked = false;
            
            var TempData = this.state.SelectedTemp;
            TempData !== undefined && TempData !== null && TempData.length && TempData.forEach(el1 =>{
                if(lstZones.some((el2) => el2.toString() === el1.toString())){
                    lstTemps.push(el1);
                }
            })

            this.setState({ SelectedZones : lstZones, SelectedTemp : lstTemps });
        }else{
            var lst_Temps = ZoneChildChks.map(elem => { return elem.checked ? elem.value : ""});
            lstTemps = (lst_Temps !== undefined && lst_Temps !== null && lst_Temps.length) ? lst_Temps.filter(el => el !== "") : [];
            this.refs.ref_TempHeader_chk.checked =  (ZoneChildChks.length === lstTemps.length) ? true : false;
            this.setState({ SelectedTemp : lstTemps });
        }          
    }

    render(ClientSideZonesState, ClientSideEmployeeState, getResponse, ClientSideComapnyState, IsUserIdNameExixts) {
        if (this.state.redirect) {
            if(this.props.ClientSideComapnyState != undefined){
                if(this.props.ClientSideComapnyState.HasMeter)
                    return <Redirect to={"/managetenant/TenantMeters"} />
                else if(this.props.ClientSideComapnyState.HasFixedRate)   
                    return <Redirect to={"/managetenant/TenantFixedCharges"} />   
                else              
                    return <Redirect to={"/managetenant/ConfirmTenantSettings"} />
            }
        }
        if (this.state.back) {
            return <Redirect to={"/managetenant/TenantNormalHours"} />
        }

        let Tenant_Zones, Modal_Form_Open, Employee_Rows, Password_fields, Header_Text, IsAllChecked = true, IsTempAllChecked = true, enableTempHeader = false;

        var ViewUserInfo = this.state.SelectedUser;
        var view_logonname = '';
        var view_FirstName = '';
        var view_LastName = '';
        var view_Email = '';
        var view_EmpPreference = 0;
        var view_ZoneIds = [], view_TempZoneIds = [];

        for (let i = 0; i < ViewUserInfo.length; i++) {
            view_logonname = ViewUserInfo[i].LogOnName;
            view_FirstName = ViewUserInfo[i].FirstName;
            view_LastName = ViewUserInfo[i].LastName;
            view_Email = ViewUserInfo[i].EmployeeEmail;
            view_EmpPreference = ViewUserInfo[i].EmployeePreference;

            // eslint-disable-next-line react/no-direct-mutation-state
            this.state.IsOktaUser = ViewUserInfo[i].IsTraneConnectUser;
        }
        view_ZoneIds = this.state.SelectedZones;
        view_TempZoneIds = this.state.SelectedTemp;

        if (this.props.ClientSideZonesState != undefined) {
            if (this.props.ClientSideZonesState.length) {
                Tenant_Zones = this.props.ClientSideZonesState.map(el => {
                    var HasChecked = view_ZoneIds != undefined && view_ZoneIds != "" ? view_ZoneIds.filter(ele => ele == el.zoneId).length > 0 : false;
                    if(!HasChecked) IsAllChecked = false;
                    var HasTempChecked = view_TempZoneIds !== undefined && view_TempZoneIds !== "" ? view_TempZoneIds.filter(ele => ele == el.zoneId).length > 0 : false;
                    if(!HasTempChecked) IsTempAllChecked = false;
                    var IsSingleMemberZone = false;
                    if(el.memberDetails !== null && el.memberDetails.length){
                        var ObjectCount = el.memberDetails.filter(ele => ele.objectType !== 4 && ele.objectType !== 5).length;
                        IsSingleMemberZone = ObjectCount === 1 ? true : false;
                    }
                    if(HasChecked && IsSingleMemberZone){
                        enableTempHeader = true;
                    }
                    return <tr>
                        <td>{el.zoneName}</td>
                        <td>{el.buildingName}</td>
                        <td>{el.members}</td>
                        <td><input type="checkbox" ref={'ref_' + el.zoneId} value={el.zoneId} checked={HasChecked} className="TenantZones_child_Check_box"  onClick={() => { this.OnClickChildChk("TenantZones_header_Check_box", "TenantZones_child_Check_box", true); }}/></td>
                        <td><input type="checkbox" ref={'ref_Temp_' + el.zoneId} value={el.zoneId}  disabled={!HasChecked || !IsSingleMemberZone} checked={HasTempChecked && HasChecked && IsSingleMemberZone} className="ZonesTemp_child_Check_box" onClick={() => { this.OnClickChildChk("ZonesTemp_header_Check_box", "ZonesTemp_child_Check_box", false); }}/></td>
                    </tr>
                }
                );
            }
            else {
                Tenant_Zones =
                    <tr>
                        <td colSpan={4}>No Records Found</td>
                    </tr>
                    IsAllChecked = false;
                    IsTempAllChecked = false;
            }
        }
        else {
            Tenant_Zones = <p>Loading Data</p>
            IsAllChecked = false;
            IsTempAllChecked = false;
        }

        if (this.state.tenantUsers != undefined) {
            if (this.state.tenantUsers.length) {
                Employee_Rows = this.state.tenantUsers.map(el => (
                    <tr>
                        <td><input type="checkbox" ref={'ref1_' + el.Key} value={el.Key} className="Employees_child_Check_box" /></td>
                        <td ><p className="link_cursor"  style={{ color: '#6890C6' }} onClick={() => { this.ViewEmployeeDetailslink(el.Key) }} >{el.FirstName} {el.LastName}</p></td>
                        <td>{el.EmployeeEmail}</td>
                        <td>{el.ZoneName}</td>
                        {
                            el.ZonesTemperatureAdjustment.filter(x => x.AllowTemperatureAdjustment === true).length ?
                            <td>Allowed</td> : <td>Not Allowed</td>
                        }
                    </tr>
                ));
            }
            else {
                Employee_Rows =
                    <tr>
                        <td colSpan={5}>No Records Found</td>
                    </tr>
            }
        }

        if (this.state.IsError) {
            var errormsg = <p className="error_msg">
                <img src={ErrorGif} alt="Trane Logo" />
                {this.state.ErrorDetails}
            </p>
        }
        if(this.state.IsNameError){
            var errornamemsg = <p className="error_msg">
                <img src={ErrorGif} alt="Trane Logo" />
                Error: Duplicate Login Name.
            </p>
        }

        if (this.state.IsPageError) {
            var pageerrormsg = <p className="error_msg">
                <img src={ErrorGif} alt="Trane Logo" />
                Error: Select one or more employee to perform this action.
            </p>
        }

        if(this.state.ResetError){
            var reseterrormsg = <p className="error_msg">
            <img src={ErrorGif} alt="Trane Logo" />
            {MismatchErrorText}
        </p>   
        }
      
        if(!this.state.IsOktaUser){
            if (this.state.userID > -1)
            {
                Password_fields = <div className="form_group_modal">
                <Label className="Custom_label"> Password*</Label>
                <Label id='lbl_Emp_ResetPwd' onClick={this.OpenReset} style={{ color: '#6890C6' }}>Reset</Label>
                </div>
                Header_Text = "Edit Tenant Employee";
            }
            else
            {
                Password_fields = <div><div className="form_group_modal">
                <Label className="Custom_label"> Password*</Label>
                <input ref='password' id='txt_Emp_Pwd' type="password" className="custom_input default-input" />
                <span className="ErrorMark" hidden={ErrPwd} >!</span>
            </div>

            <div className="form_group_modal"> 
                <Label className="Custom_label">Confirm Password*</Label>
                <input ref='confirmPassword' id='txt_Emp_ConfirmPwd' type="password" className="custom_input default-input" />
                <span className="ErrorMark" hidden={ErrConfirmPwd} >!</span>
            </div>
            </div>

            Header_Text = "Add Tenant Employee";
            }
        }else {
            if (this.state.userID > -1) {
                Password_fields = <div className="form_group_modal">
                    <Label className="Custom_label"> Password*</Label>
                    <Label style={{ color: '#6890C6' }}>Reset</Label>
                </div>
                Header_Text = "Edit Tenant Employee";
            }
            else{
                Password_fields = <div><div className="form_group_modal">
                <Label className="Custom_label"> Password*</Label>
                <input ref='password' id='txt_Emp_Pwd' type="password" className="custom_input default-input" disabled="true"/>
                </div>
                <div className="form_group_modal">
                    <Label className="Custom_label">Confirm Password*</Label>
                    <input ref='confirmPassword' id='txt_Emp_ConfirmPwd' type="password" className="custom_input default-input" disabled="true" />
                </div>
                </div>  
                Header_Text = "Add Tenant Employee";
            }
        }

        Modal_Form_Open = <div >
            <div>
                <h7 className="form_sub_title padding_Form_Left">{Header_Text}</h7>
                <br />
                <br />
                <Label className="padding_Form_Left">Enter information to uniquely identify an employee for after hours requests. Select which subgroup(s) and zone(s) the employee can make requests for. </Label>
                {errormsg}
                {errornamemsg}
                <legend className="form_sub_title padding_Form_Left">Employee Information</legend>

                
                {/* <div className="form_group_modal ">
                    <FormGroup check>
                       {(this.state.userID > -1)? "":<Label check>
                        <Input type="checkbox" checked={this.state.IsOktaUser} onClick={this.OnCheckOktaUser} style={{marginTop:(this.props.OnPremises) ? "0px": {}}}/> Is Okta User
                        </Label>}
                    </FormGroup>
                </div> */}

                <div className="form_group_modal ">
                    <Label className="Custom_label">User ID*</Label>
                    <input ref='userid' id="createtenant_emp_userid" className="custom_input default-input" defaultValue={view_logonname} />
                    <span className="ErrorMark" hidden={ErrLogOnName} >!</span>
                </div>

                <div className="form_group_modal">
                    <Label className="Custom_label">First Name*</Label>
                    <input ref='firstName' id="createtenant_emp_fname" className="custom_input default-input" defaultValue={view_FirstName} />
                    <span className="ErrorMark" hidden={ErrFName} >!</span>
                </div>

                <div className="form_group_modal">
                    <Label className="Custom_label">Last Name*</Label>
                    <input ref='lastName' id="createtenant_emp_lname" className="custom_input default-input" defaultValue={view_LastName} />
                    <span className="ErrorMark" hidden={ErrLName} >!</span>
                </div>


                <div className="form_group_modal">
                    <Label className="Custom_label"> E-mail Address</Label>
                    <input ref='email' id="createtenant_emp_email" autocomplete='new-email' className="custom_input default-input" defaultValue={view_Email} />
                    <span className="ErrorMark" hidden={ErrEmail} >!</span>
                </div>


                <div className="form_group_modal form_odd_div">
                    <Label className="Right_Aligned_Label">Required for employees that need to receive Facility Request e-mail confirmations</Label>
                </div>

                    {Password_fields}

                <div className="form_group_modal ">
                    <Label className="Custom_label_small_width">Display Temperatures in</Label>

                    <select ref='displayTemp' id="createtenant_emp_temp" defaultValue={view_EmpPreference} className="custom_input default-input " >
                        <option value="0">Degrees Fahrenheit</option>
                        <option value="1">Degrees Celsius</option>
                    </select>

                </div>
                <br />

                <div className="form_group_modal" style={{"padding-left":"0px", "margin-bottom": "0px"}}>
                    <span style={{"font-weight": "bold",  "line-height" : "20px", "font-size": "14px"}}>Zone Access and Temperature Adjustment Permissions</span>
                    <br/>
                    <span style={{"font-size": "13px"}}>{"Temperature access can’t be granted unless Zone access is granted. Temperature can be enabled only if the zone has a single space or area."}</span>
                </div>

                <div style={{width:'100%', overflowY:'auto', maxHeight:'280px'}}>
                <Table striped responsive className="Custom_table table_border" id='tbl_Emp_Zones'>
                    <tbody className="cell_container tenant_cell">
                        <tr>
                            <th style={{ width: '20%' }}>Zone</th>
                            <th style={{ width: '20%' }}>Building</th>
                            <th style={{ width: '20%' }}>Members</th>
                            <th style={{ width: '8%' }}><input type="checkbox" className="TenantZones_header_Check_box" style={{"margin-right" : "5px"}} checked={IsAllChecked} onClick={() => { this.OnClickHeaderChk("TenantZones_header_Check_box", "TenantZones_child_Check_box", true); }} />Zone</th>
                            <th style={{ width: '13%' }}><input type="checkbox" disabled={!enableTempHeader} className="ZonesTemp_header_Check_box" style={{"margin-right" : "5px"}} ref="ref_TempHeader_chk" defaultChecked={IsTempAllChecked} onClick={ () => {this.OnClickHeaderChk("ZonesTemp_header_Check_box", "ZonesTemp_child_Check_box", false);} } />Temperature</th>
                        </tr>
                        {Tenant_Zones}
                    </tbody>
                </Table>
                </div>

                <FormGroup row className="btns_group">
                    <Col sm={{ size: 10 }}>
                        <Button id="createtenant_emp_cancelemp" className="btn-gray btn-md" onClick={this.OnCancelAddEmployee.bind(this)} > Cancel </Button>
                        <Button id="createtenant_emp_save" className="btn-success" onClick={() => { this.OnSaveTenant(Tenant_Zones); }} > Done </Button>
                        {/* <Button className="btn-black btn-md"> Save </Button> */}
                    </Col>
                </FormGroup>
            </div>
        </div>

        return (
            <div className="EnsembleCreateTenant">
                <Row>
                    <Col sm={{ size: 1, offset: 11 }} className="text-right" >
                        <FaQuestionCircle className="Ensemble_Icon Ensemble_question_Icon" />
                    </Col>
                </Row>
                <h5 className="form_title">Create Tenant - Create Tenant Employee Users</h5>
                {pageerrormsg}
                <div className="Customised_form_div">
                    <Button type="button" id="createtenant_emp_delete" className="btn btn-black" onClick={() => { this.DeleteEmployee(Employee_Rows); }}>Delete  </Button>
                    <Button type="button" id="createtenant_emp_add" className="btn btn-success  TenantActionBtns" onClick={this.toggle}>Create New Employee  </Button>

                <div className="table_container" style={{paddingRight:'15px'}}>
                    <Table striped responsive className="Custom_table table_border">
                        <tbody className="cell_container tenant_cell">
                            <tr>
                                <th style={{ width: '5%' }}><input type="checkbox" className="Employees_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("Employees_child_Check_box", "Employees_header_Check_box"); }} /></th>
                                <th style={{ width: '20%' }}>Employee</th>
                                <th style={{ width: '20%' }}>E-mail</th>
                                <th style={{ width: '30%' }}>Zones</th>
                                <th style={{ width: '25%' }}>Temperature Setting Adjustments</th>
                            </tr>
                            {Employee_Rows}
                        </tbody>
                    </Table>
                </div>

                    <FormGroup row className="btns_group">
                        <Col sm={{ size: 10 }}>
                            <Button id="createtenant_emp_back" className="btn-gray" onClick={this.goBack} > {"<"} Back </Button>
                            <Button id="createtenant_emp_next" className="btn-success" onClick={this.goNext}>Next {">"}</Button>
                        </Col>
                    </FormGroup>
                </div>


                <Modal isOpen={this.state.modal} zIndex = "2147483646" toggle={this.toggle} className={this.props.className}>
                    {Modal_Form_Open}
                    {/* <AddTenantEmployee tenant={this.state.tenant} /> */}
                </Modal>
                
                <Modal isOpen={this.state.Reset} zIndex = "2147483646" toggle={this.toggle} className={this.props.className}>
                    <div>
                    <h4 className="form_title">Reset Employee Password</h4>
                    {reseterrormsg}
                        <div className="form_group_modal">
                            <Label className="Custom_label">New Password*</Label>
                            <input ref='NewPassword' id='txt_NewPwd' type="password" className="custom_input default-input" />
                            <span className="ErrorMark" hidden={ErrResetPwd} >!</span>
                        </div>

                        <div className="form_group_modal">
                            <Label className="Custom_label">Confirm Password*</Label>
                            <input ref='NewConfirmPassword' id='txt_confirmPwd' type="password" className="custom_input default-input" />
                            <span className="ErrorMark" hidden={ErrResetConfirmPwd} >!</span>
                        </div>

                        <FormGroup row className="btns_group">
                            <Col sm={{ size: 10 }}>
                                <Button className="btn-gray btn-md" id='btn_Pwd_Cancel' onClick={this.CancelResetPassword} > Cancel </Button>
                                <Button className="btn-success btn-md" id='btn_Pwd_Reset' onClick={this.ResetPassword}  > Save </Button>
                                {/* <Button className="btn-black btn-md"> Save </Button> */}
                            </Col>
                        </FormGroup>
                    </div>
                </Modal>

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        ClientSideZonesState: state.manageTenant.ClientSideZonesData,
        ClientSideEmployeeState: state.manageTenant.ClientSideEmployeesData,
        getResponse: state.EmployeeRootReducer,
        ClientSideComapnyState: state.manageTenant.ClientSideComapnyData,
        IsUserIdNameExixts: state.ViewtenantsRootReducer.IsLogOnNameExists,
        OnPremises: state.authService.IsOnPremise
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetRegularExpresions: () => dispatch(GetRegularExpresions()),
        CheckIsLogOnNameExists: (name) => dispatch(CheckIsLogOnNameExists(name)),
        SaveEmployeeDetailsforclient: (data) => dispatch(SaveEmployeeDetailsforclient(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateTenant_Employee);